import { createContext, ReactNode, useContext, useEffect, useMemo, useState, JSX } from 'react';
import { useApi } from './useApi';
import { IProfile } from '../models/interfaces';
import { AxiosResponse } from 'axios';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
interface LoggedContextType {
  loggedUser?: IProfile;
}

const LoggedContext = createContext<LoggedContextType>({} as LoggedContextType);

export function LoggedContextProvider({ children }: { children: ReactNode }): JSX.Element {
  const [loggedUser, setLoggedUser] = useState<IProfile>();
  const auth = useAuth();
  const { defaultApi } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLoading) {
      return; // Ancora in caricamento
    }
    if (auth.isAuthenticated && auth.user) {
      defaultApi.profileGet().then((resp: AxiosResponse<any>) => {
        if (resp.status === 200) {
          setLoggedUser(resp.data);
        } else {
          navigate('/logout');
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.user, defaultApi]);

  const cachedValue: LoggedContextType = useMemo(
    () => ({
      loggedUser,
    }),
    [loggedUser],
  );

  return <LoggedContext.Provider value={cachedValue}>{children}</LoggedContext.Provider>;
}

//hook per utilizzo webSocket
export const useLogged = () => useContext(LoggedContext);
